<template>
  <h3 class="h3">Ich habe Interesse an einem</h3>
  <RadioMenu v-model="preInterestRadio" :options="options"/>
  <div class="flex justify-between mt-5 items-center">
    <div style="width: 75px"></div> <!-- spacer to keep the next button right aligned -->
    <input type="button" class="button next" :disabled="nextDisabled" :value="Navigation.WEITER" @click="next"/>
  </div>
  <div class="text-center">
    <span class="!text-gray-200 !text-xs !font-sans">digital begeistert von <a href="https://www.codeandcomments.at" class="!underline !text-xs !text-gray-200 !font-sans">code & comments</a></span>
  </div>
</template>

<script setup>
import RadioMenu from '../../components/RadioMenu.vue'
import { computed } from 'vue';
import { DetailStep, VorauswahlInteresse, Navigation } from '../../models/enums'
import { useStore } from 'vuex';
import { scrollToTop } from '@/models/helper';

const options = Object.values(VorauswahlInteresse);
const store = useStore();
const nextDisabled = computed(() => store.state.preInterest == null);

const next = () => {
  if (store.state.preInterest == VorauswahlInteresse.FÜHRERSCHEIN) {
    store.commit("updateStep", DetailStep.VORAUSWAHL_FÜHRERSCHEIN);
  } else {
    store.commit("updateStep", DetailStep.VORAUSWAHL_FREIWILLIG);
  }

  scrollToTop();
}
const preInterestRadio = computed({
  get: () => store.state.preInterest,
  set: value => store.commit("updatePreInterest", value)
});
</script>

<style scoped>
h3 {
  @apply mb-2;
}
</style>
